"use strict"

import _ from "lodash"
import moment from "moment"
import i18n from "@/plugins/i18n"
import vuetify from "@/plugins/vuetify"
export * from "./reportDownload"

const FORMAT_DATE = i18n.t("format.Date")
export const toDate = (time) => moment(time).format(FORMAT_DATE)

const FORMAT_DATETIME = i18n.t("format.DateTime")
export const toDateTime = (time) => moment(time).format(FORMAT_DATETIME)

const FORMAT_MONTH = i18n.t("format.Month")
export const toMonth = (time) => moment(time).format(FORMAT_MONTH)
export const toHourMinute = (sec) => {
  sec = parseInt(sec || 0)
  const min = parseInt(sec/60)
  return i18n.t("format.HourMinute", {hour: parseInt(min/60), min: _.padStart(min%60, 2, 0)})
}

export const toDuration = (sec) => {
  sec = parseInt(sec || 0)
  return i18n.t("format.Duration", {min: parseInt(sec/60), sec: _.padStart(sec%60, 2, 0)})
}

export const toRecorderStatus = (status) => i18n.t(`recorder.${status.toLowerCase()}`)
const RECORDER_COLOR = {
  ready: vuetify.theme.primary,
  "no mic": vuetify.theme.unavailable,
  updating: vuetify.theme.progress,
  recording: vuetify.theme.rec,
  uploading: vuetify.theme.progress,
  diskfull: vuetify.theme.cancel,
  error: vuetify.theme.cancel,
  dead: vuetify.theme.cancel,
}
export const toRecorderColor = (status) => RECORDER_COLOR[status] || vuetify.theme.cancel
export const toDiscussionStatus = (status) => i18n.t(`discussion.${status}`)
const DICSUSSION_COLOR = {
  created: vuetify.theme.cancel,
  recording: vuetify.theme.rec,
  uploading: vuetify.theme.progress,
  uploaded: vuetify.theme.progress,
  queue: vuetify.theme.progress,
  analyzing: vuetify.theme.primary,
  completed: vuetify.theme.primary,
  error: vuetify.theme.cancel,
  canceled: vuetify.theme.cancel,
}
export const toDiscussionColor = (status) => DICSUSSION_COLOR[status] || vuetify.theme.cancel

export const changed = (before, after) => {
  before = before || {}
  return _.omitBy(after, (v, k) => v === before[k])
}

export const generatePassword = (length) => {
  const chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890"
  return _.sampleSize(chars, length).join("")
}

export const generateId = (length) => {
  return generatePassword(length)
}

export const formatDuration = (ms, needHour) =>{
  ms = Math.max(0, ms)
  if(!_.isNumber(ms)) return ""
  const sec = parseInt(ms/1000)
  const min = parseInt(sec/60)
  const hour = parseInt(min/60)
  if(needHour) return `${hour}`+":"+`${min%60}`.padStart(2, 0)+":"+`${sec%60}`.padStart(2, 0)
  else return                          `${min}`.padStart(2, 0)+":"+`${sec%60}`.padStart(2, 0)
}

export const parseDuration = (str) => {
  const match = str.match(/^((\d+):)?(\d+):(\d{1,2})$/)
  if(!match) return null
  const h = _.parseInt(match[2] || 0)
  const m = _.parseInt(match[3])
  const s = _.parseInt(match[4])
  if((h > 0 && m > 60) || s > 60) return null
  const time = h*3600 + m*60 + s
  return time * 1000
}

export const getBrowserType = () => {
  const keywords = ["msie", "trident"/*ie11*/, "edge", "chrome", "crios", "safari", "firefox", "opera"]

  const userAgent = window.navigator.userAgent.toLowerCase()
  for(let kw of keywords){
    if(userAgent.indexOf(kw) != -1) return kw
  }
  return "unknown"
}

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const hash = async (str) => {
  const data = new TextEncoder().encode(str)
  const hashBuf = await crypto.subtle.digest("SHA-256", data)
  const hashArray = Array.from(new Uint8Array(hashBuf))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("")
  return hashHex
}

export const REGEX_INVALID_SYMBOL = /[!"#$%&'*+,/:;<=>?@\\^`{|}~]/g
export const REGEX_RECORDER_ID = /^[0-9A-Fa-f]{12}$/

export const fireResizeEvent = () => window.dispatchEvent(new Event("resize"))
export const setHelpWidgetVisible = (visible) => window.zE?.("messenger", visible ? "show" : "hide")
